import { render, staticRenderFns } from "./DetailFooterButtons.vue?vue&type=template&id=0f5974d5&scoped=true"
import script from "./DetailFooterButtons.vue?vue&type=script&lang=js"
export * from "./DetailFooterButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5974d5",
  null
  
)

export default component.exports